import React, {Component} from 'react';
import {Collapse} from 'reactstrap';
import ReactDOM from "react-dom";

export default class FaqAccordionItem extends Component {

    constructor(props) {
        super(props);

        this.state = {
            collapse: false
        };

        this.toggle = this.toggle.bind(this);
        this.arrowStyle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({collapse: !this.state.collapse});
    }

    createMarkup(answer) {
        return {__html: answer};
    }

    render() {
        return (
            <React.Fragment>
                <div className="row faq-row" onClick={this.toggle}>
                    <div className="col-12 d-flex flex-row justify-content-between" style={{fontWeight: '600'}}>
                        <div>{this.props.question.question}</div>
                        <div className="pr-3"><img className={this.state.collapse ? 'arrow-open' : 'arrow-closed'} src="/assets/img/arrow-small.svg" width='10' alt="arrow"/></div>
                    </div>
                    <Collapse isOpen={this.state.collapse}>
                        <div className="col-12 pt-3" dangerouslySetInnerHTML={this.createMarkup(this.props.question.answer)}/>
                    </Collapse>
                </div>
                <hr className="accordion-divider"/>
            </React.Fragment>
        );
    }
}
